import $ from 'jquery';
import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y';

const PREFIX = 'modal';

const config = {
  loadingClass: `${PREFIX}-container--loading`,
  modalOpenedClass: `${PREFIX}--opened`,
  wrapperHtml: `
    <div class="${PREFIX}-container">
      <div class="${PREFIX}-container__backdrop"></div>
      <span class="${PREFIX}-container__loader"></span>
    </div>
  `,
  modalHtml: `
    <div class="${PREFIX}">
      <div class="${PREFIX}__inner">
        <button type="button" class="${PREFIX}__close">
          <span class="${PREFIX}__close-icon">&times;</span>
        </button>
        <div class="${PREFIX}__content">{{CONTENT}}</div>
      </div>
    </div>
  `,
};

let instance = null;

export class SiteModal {

  constructor() {
    if (instance) return instance;
    instance = this;

    this.$body = $('body');
    this.$wrapper = $(config.wrapperHtml).appendTo('body');
    this.$popup = null;
    this.wrapperOpened = false;
    this.triggerElement = null;
    this._closeTimer = null;
    this._openTimer = null;
    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.close();
    };
  }

  loading(state) {
    if (!this.wrapperOpened) {
      this.triggerElement = document.activeElement;
      this._openWrapper();
    }

    if (state) {
      this.$wrapper.addClass(config.loadingClass);
    } else {
      this.$wrapper.removeClass(config.loadingClass);
    }
  }

  open(content) {
    if (this.$popup) {
      this.$popup.remove();
    }

    this.$popup = $(config.modalHtml.replace('{{CONTENT}}', content));
    this.$popup.appendTo(this.$wrapper);

    $(`.${PREFIX}__close`, this.$popup).on('click', this.close.bind(this));
    $(`.${PREFIX}-container__backdrop`, this.$wrapper).one('click', this.close.bind(this));

    this._openTimer = setTimeout(() => {
      this.loading(false);
      this.$popup.addClass(config.modalOpenedClass);
      trapFocus(this.$popup[0]);
    }, 300);
  }

  close() {
    clearTimeout(this._openTimer);
    removeTrapFocus();

    if (this.$popup) {
      this.$popup.removeClass(config.modalOpenedClass);
    }

    this._closeTimer = setTimeout(() => {
      this._closeWrapper();
      if (this.$popup) {
        this.$popup.remove();
        this.$popup = null;
      }
    }, 300);
  }

  getModal() {
    return this.$popup;
  }

  _returnFocus() {
    if (this.triggerElement && document.body.contains(this.triggerElement)) {
      this.triggerElement.focus();
    } else {
      document.body.focus();
    }
    this.triggerElement = null;
  }

  _openWrapper() {
    this.wrapperOpened = true;
    this.$wrapper.fadeIn(300);
    this.$body.css({
      overflow: 'hidden',
      paddingRight: `${window.innerWidth - document.documentElement.clientWidth}px`,
    });
    document.addEventListener('keydown', this._onKeydown);
  }

  _closeWrapper() {
    this.wrapperOpened = false;
    this.$wrapper.fadeOut(300);
    this.$body.css({
      overflow: '',
      paddingRight: '',
    });
    document.removeEventListener('keydown', this._onKeydown);
    this._returnFocus();
  }
}
